/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

// import type { components } from '@/ts/api/core/schema.generated.d.ts'

type APIPreferences = unknown

export class Preferences {
  constructor() {}

  toJSON() {
    return null
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO
  static fromJSON(prefs: APIPreferences) {
    return new Preferences()
  }
}
